import { memo } from 'react';
import { FormProvider } from 'react-hook-form';
import EligibilityRules from '../eligibility-rules/eligibility-rules';
import { SectionContainer } from './styles';
import type { EligibilityRulesForm } from './types';

interface EligibilityRulesElementProps {
  form: EligibilityRulesForm;
  isScheduledVersion?: boolean;
}

const EligibilityRulesElement = ({
  form,
  isScheduledVersion,
}: EligibilityRulesElementProps) => (
  <SectionContainer>
    <FormProvider {...form}>
      <EligibilityRules isScheduledVersion={isScheduledVersion} />
    </FormProvider>
  </SectionContainer>
);

export default memo(EligibilityRulesElement);
